import { render } from "./Item7.vue?vue&type=template&id=f2d3b6c4"
import script from "./Item7.vue?vue&type=script&lang=ts"
export * from "./Item7.vue?vue&type=script&lang=ts"
script.render = render

export default script